// src/components/YogaSessions.js
import React from 'react';
import './YogaSessions.css';

const YogaSessions = () => {
  return (
    <section className="yoga-sessions-section" id="sessions">
      {/* Section 1 */}
      <div className="session-section-1">
        <h2 className="session-heading">
          Sessions and Timing
          <span className="heading-underline" />
        </h2>

        <div className="tables-row">
          {/* Morning */}
          <div className="session-table card">
            <div className="table-title">
              <span className="badge badge-sun">☀️</span>
              <h3>Morning Session</h3>
            </div>
            <div className="table-scroll">
              <table className="table-modern">
                <thead>
                  <tr>
                    <th>Activity</th>
                    <th>Timing</th>
                    <th>Fees</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Daily Yoga session</td>
                    <td>6:00 to 7:00 am</td>
                    <td><span className="pill-fee">₹ 1500</span></td>
                  </tr>
                  <tr>
                    <td>Daily Yoga session</td>
                    <td>7:00 to 8:00 am</td>
                    <td><span className="pill-fee">₹ 1500</span></td>
                  </tr>
                  <tr>
                    <td>Daily Yoga session</td>
                    <td>8:00 to 9:00 am</td>
                    <td><span className="pill-fee">₹ 1500</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Evening */}
          <div className="session-table card">
            <div className="table-title">
              <span className="badge badge-moon">🌙</span>
              <h3>Evening Session</h3>
            </div>
            <div className="table-scroll">
              <table className="table-modern">
                <thead>
                  <tr>
                    <th>Activity</th>
                    <th>Timing</th>
                    <th>Fees</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Daily Yoga session</td>
                    <td>5:00 to 6:00 pm</td>
                    <td><span className="pill-fee">₹ 1500</span></td>
                  </tr>
                  <tr>
                    <td>Daily Yoga session</td>
                    <td>6:00 to 7:00 pm</td>
                    <td><span className="pill-fee">₹ 1500</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      {/* Section 2 */}
      <div className="session-section-2">
        <div className="personal-table card">
          <div className="table-title">
            <span className="badge badge-leaf">🧘‍♀️</span>
            <h3>Other Yoga Services</h3>
          </div>
          <div className="table-scroll">
            <table className="table-modern">
              <thead>
                <tr>
                  <th>Activity</th>
                  <th>Fees</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Personal Yoga Classes</td>
                  <td><span className="pill-fee">₹ 12,000</span></td>
                </tr>
                <tr>
                  <td>Pregnancy Yoga</td>
                  <td><span className="pill-fee">₹ 15,000</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="session-guidelines card">
          <div className="table-title">
            <span className="badge badge-note">📒</span>
            <h3>Guidelines for All Members</h3>
          </div>
          <ul className="guidelines-list">
            <li>Fees deposited once is non-refundable and non-transferable in any situation.</li>
            <li>Fees will be paid for the entire one month.</li>
            <li>No holidays will be compensated.</li>
            <li>Kindly bring your own yoga mat.</li>
            <li>The students are expected to share their medical problems with the teacher before starting the class.</li>
            <li>The result of therapy Yoga varies person to person.</li>
            <li>Yoga therapy is a natural process of healing so have patience in results.</li>
            <li>Kindly give your 100% in getting good results.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default YogaSessions;
